import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Imprint from './components/Imprint';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Alerts from './pages/Alerts';
import Devices from './pages/Devices';
import Facilities from './pages/Facilities';
import Providers from './pages/Providers';
import DeviceSetupWizard from './pages/DeviceSetupWizard';
import MobileSetup from './pages/MobileSetup';
import { User, Facility } from './types';
import { getFacilities } from './services/api';

function App() {
  const [user, setUser] = useState<User | null>(null);
  const [facilities, setFacilities] = useState<Facility[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    const storedFacility = localStorage.getItem('selectedFacility');

    if (token && userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
      setSelectedFacility(storedFacility || parsedUser.facility.id);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user) {
      loadFacilities();
    }
  }, [user]);

  const loadFacilities = async () => {
    try {
      const data = await getFacilities();
      setFacilities(data);
    } catch (error) {
      console.error('Error loading facilities:', error);
    }
  };

  const handleLogin = (userData: User, token: string) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('selectedFacility');
    setUser(null);
    setSelectedFacility('');
  };

  const handleFacilityChange = (facilityId: string) => {
    setSelectedFacility(facilityId);
    localStorage.setItem('selectedFacility', facilityId);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 flex flex-col">
      <Routes>
        <Route
          path="/login"
          element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
        />
        <Route
          path="/"
          element={user ? <Dashboard user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/patients"
          element={user ? <Patients user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/patients/:id"
          element={user ? <PatientDetail user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/alerts"
          element={user ? <Alerts user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/devices"
          element={user ? <Devices user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/facilities"
          element={user ? <Facilities user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/providers"
          element={user ? <Providers user={user} onLogout={handleLogout} facilities={facilities} selectedFacility={selectedFacility} onFacilityChange={handleFacilityChange} /> : <Navigate to="/login" />}
        />
        <Route
          path="/setup/:deviceId"
          element={<DeviceSetupWizard />}
        />
        <Route
          path="/setup/:deviceId/mobile"
          element={<MobileSetup />}
        />
      </Routes>
        </div>
        <Imprint />
      </div>
    </BrowserRouter>
  );
}

export default App;
